import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { CargoProblemDetail } from '@magimp/shared';
import { Icon, SectionCard } from '../../../ui/index.js';

export function CargoProblemCargoCard({ problem }: { problem: CargoProblemDetail }) {
  const { t } = useTranslation('cargoProblems');
  const cargo = problem.cargo;
  const title = cargo ? [cargo.article, cargo.nameGoods].filter(Boolean).join(' · ') || '—' : '';
  return (
    <SectionCard title={t('detail.cargo')}>
      {cargo ? (
        <div className="cargo-problem-cargo-context">
          <Link
            className="cargo-problem-cargo-link"
            to={cargo.article ? `/cargo?q=${encodeURIComponent(cargo.article)}` : '/cargo'}
            aria-label={t('detail.openCargo', { cargo: title })}
          >
            <span>{title}</span>
            <Icon name="external-link" size={14} />
          </Link>
          <dl className="cargo-problem-facts">
            <Fact label={t('list.columns.tariff')} value={cargo.transportationTariff ?? '—'} />
            <Fact label={t('dimensions.weight')} value={cargo.weight ?? '—'} />
            <Fact label={t('dimensions.volume')} value={cargo.volume ?? '—'} />
            <Fact label={t('list.columns.carrier')} value={cargo.carrier ?? '—'} />
          </dl>
        </div>
      ) : (
        <p>{t('cargoUnavailable')}</p>
      )}
    </SectionCard>
  );
}

function Fact({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
}
